// DO NOT EDIT THIS FILE. This file auto-generated, use `npm run sync-icons` to update icons
export { ReactComponent as AccountVerificationProgressIcon } from '../svg/account-verification-progress.svg'
export { ReactComponent as AddtoscreenIcon } from '../svg/addtoscreen.svg'
export { ReactComponent as AmericanFootballIcon } from '../svg/americanFootball.svg'
export { ReactComponent as AndroidIcon } from '../svg/android.svg'
export { ReactComponent as AnimationsIcon } from '../svg/animations.svg'
export { ReactComponent as ArrowDownRedIcon } from '../svg/arrow-down-red.svg'
export { ReactComponent as ArrowRightShortIcon } from '../svg/arrow-right-short.svg'
export { ReactComponent as ArrowRightIcon } from '../svg/arrow-right.svg'
export { ReactComponent as BalanceProfileIcon } from '../svg/balanceProfile.svg'
export { ReactComponent as BarChartFillIcon } from '../svg/bar-chart-fill.svg'
export { ReactComponent as BaseballIcon } from '../svg/baseball.svg'
export { ReactComponent as BasketballBadgeIcon } from '../svg/basketball-badge.svg'
export { ReactComponent as BasketballIcon } from '../svg/basketball.svg'
export { ReactComponent as BellSolidIcon } from '../svg/bell-solid.svg'
export { ReactComponent as BetaSignup } from '../svg/beta_signup.svg'
export { ReactComponent as BitcoinBadgeIcon } from '../svg/bitcoin-badge.svg'
export { ReactComponent as BombIcon } from '../svg/bomb.svg'
export { ReactComponent as BrandLogoIcon } from '../svg/brand-logo.svg'
export { ReactComponent as BtcLiveIcon } from '../svg/btc-live.svg'
export { ReactComponent as CalendawhiteIcon } from '../svg/calendawhite.svg'
export { ReactComponent as CardArrowIcon } from '../svg/card-arrow.svg'
export { ReactComponent as CasinoMenuIcon } from '../svg/Casino-menu.svg'
export { ReactComponent as ChatBadgeIconIcon } from '../svg/chat-badge-icon.svg'
export { ReactComponent as ChatBubbleIcon } from '../svg/chat-bubble.svg'
export { ReactComponent as ChatCloseIcon } from '../svg/chat-close.svg'
export { ReactComponent as ChatIcon } from '../svg/chat.svg'
export { ReactComponent as CherryBadgeIcon } from '../svg/cherry-badge.svg'
export { ReactComponent as CloseBtnIcon } from '../svg/close-btn.svg'
export { ReactComponent as CloseGrayIcon } from '../svg/closeGray.svg'
export { ReactComponent as CloseWhiteIcon } from '../svg/closeWhite.svg'
export { ReactComponent as ClutchEcosystemIcon } from '../svg/coinbatting-ecosystem.svg'
export { ReactComponent as ClutchFullLogoIcon } from '../svg/coinbatting-full-logo.svg'
export { ReactComponent as ClutchOriginalsDIcon } from '../svg/coinbatting-originals-D.svg'
export { ReactComponent as CoinFlipGameIcon } from '../svg/coin-flip-game.svg'
export { ReactComponent as CoinsIcon } from '../svg/coins.svg'
export { ReactComponent as CompletedIcon } from '../svg/completed.svg'
export { ReactComponent as ContentLoaderIcon } from '../svg/contentLoader.svg'
export { ReactComponent as CopyIcon } from '../svg/copy.svg'
export { ReactComponent as CrashGameIcon } from '../svg/crash game.svg'
export { ReactComponent as CrownBadgeIcon } from '../svg/crown-badge.svg'
export { ReactComponent as CryptoMenuIcon } from '../svg/Crypto-menu.svg'
export { ReactComponent as DepositIcon } from '../svg/Deposit.svg'
export { ReactComponent as DepositProfileIcon } from '../svg/depositProfile.svg'
export { ReactComponent as DiscordIcon } from '../svg/discord.svg'
export { ReactComponent as DragIcon } from '../svg/drag.svg'
export { ReactComponent as EmojiSmileIcon } from '../svg/emoji-smile.svg'
export { ReactComponent as EmptyIcon } from '../svg/Empty.svg'
export { ReactComponent as EyeCloseIcon } from '../svg/eye-close.svg'
export { ReactComponent as EyeIcon } from '../svg/eye.svg'
export { ReactComponent as FavRedWhiteIcon } from '../svg/fav-red-white.svg'
export { ReactComponent as FavStarHeadingIcon } from '../svg/fav-star-heading.svg'
export { ReactComponent as FavouritesDIcon } from '../svg/favourites-D.svg'
export { ReactComponent as FavouritesWIcon } from '../svg/favourites-W.svg'
export { ReactComponent as FireBadgeIcon } from '../svg/fire-badge.svg'
export { ReactComponent as FriendMenuIcon } from '../svg/Friend-menu.svg'
export { ReactComponent as GameInfoIcon } from '../svg/game-info.svg'
export { ReactComponent as GamesProviderHeadingIcon } from '../svg/games-provider-heading.svg'
export { ReactComponent as GifIcon } from '../svg/gif.svg'
export { ReactComponent as GolfIcon } from '../svg/golf.svg'
export { ReactComponent as GoogleIconSvgIcon } from '../svg/google-icon-svg.svg'
export { ReactComponent as GoogleLogoIcon } from '../svg/google-logo.svg'
export { ReactComponent as GraphSettingIcon } from '../svg/graph-setting.svg'
export { ReactComponent as GreenArrowUpIcon } from '../svg/green-arrow-up.svg'
export { ReactComponent as HamburgerIcon } from '../svg/hamburger.svg'
export { ReactComponent as HeaderMenuIconIcon } from '../svg/header-menu-icon.svg'
export { ReactComponent as HeaderSearchIcon } from '../svg/header-search.svg'
export { ReactComponent as HeadingStarIcon } from '../svg/heading-star.svg'
export { ReactComponent as HeartBadgeIcon } from '../svg/heart-badge.svg'
export { ReactComponent as HiloIcon } from '../svg/hilo.svg'
export { ReactComponent as HiveLoaderSmallIcon } from '../svg/hiveLoaderSmall.svg'
export { ReactComponent as HorseIcon } from '../svg/horse.svg'
export { ReactComponent as HotkeysIcon } from '../svg/hotkeys.svg'
export { ReactComponent as InfinitySvgrepoIcon } from '../svg/infinity-svgrepo.svg'
export { ReactComponent as InfoNewIcon } from '../svg/info-new.svg'
export { ReactComponent as InfoIcon } from '../svg/info.svg'
export { ReactComponent as InsectBadgeIcon } from '../svg/insect-badge.svg'
export { ReactComponent as InstandBetIcon } from '../svg/instand-bet.svg'
export { ReactComponent as IosIcon } from '../svg/ios.svg'
export { ReactComponent as LeftArrowIcon } from '../svg/left-arrow.svg'
export { ReactComponent as LightBadgeIcon } from '../svg/light-badge.svg'
export { ReactComponent as LimitIcon } from '../svg/limit.svg'
export { ReactComponent as LinkIcon } from '../svg/link.svg'
export { ReactComponent as LiveIcon } from '../svg/live.svg'
export { ReactComponent as LoaderIcon } from '../svg/loader.svg'
export { ReactComponent as LobbyDIcon } from '../svg/lobby-D.svg'
export { ReactComponent as LockIcon } from '../svg/Lock.svg'
export { ReactComponent as LogoutProfileIcon } from '../svg/logoutProfile.svg'
export { ReactComponent as MaxBetIcon } from '../svg/max-bet.svg'
export { ReactComponent as MetaColorIcon } from '../svg/meta-color.svg'
export { ReactComponent as TwitchIcon } from '../svg/twitch.svg'
export { ReactComponent as PhantomIcon } from '../svg/phantom.svg'
export { ReactComponent as MetaIconIcon } from '../svg/meta-icon.svg'
export { ReactComponent as MetaMaskIconNewIcon } from '../svg/meta-mask-icon-new.svg'
export { ReactComponent as MinusIcon } from '../svg/minus.svg'
export { ReactComponent as MobLogoIcon } from '../svg/mob-logo.svg'
export { ReactComponent as MobileBottomIcon } from '../svg/mobile-bottom.svg'
export { ReactComponent as MostPlayedIcon } from '../svg/most-played.svg'
export { ReactComponent as MyBetsIcon } from '../svg/myBets.svg'
export { ReactComponent as NewClutchLogoIcon } from '../svg/new-coinbatting-logo.svg'
export { ReactComponent as NewwalletIcon } from '../svg/newwallet.svg'
export { ReactComponent as NftMenuIcon } from '../svg/Nft-menu.svg'
export { ReactComponent as OptionLoadingIcon } from '../svg/option-loading.svg'
export { ReactComponent as OriginalsGamesIcon } from '../svg/originals-games.svg'
export { ReactComponent as OriginalsIcon } from '../svg/originals.svg'
export { ReactComponent as OtherGamesIcon } from '../svg/other-games.svg'
export { ReactComponent as PartnerProgramMenuIcon } from '../svg/Partner-Program-menu.svg'
export { ReactComponent as PendingIcon } from '../svg/pending.svg'
export { ReactComponent as PencilIcon } from '../svg/pencil.svg'
export { ReactComponent as PerksIcon } from '../svg/perks.svg'
export { ReactComponent as PhantomIconNewIcon } from '../svg/Phantom-icon-new.svg'
export { ReactComponent as PlinkoIcon } from '../svg/Plinko.svg'
export { ReactComponent as PlusIcon } from '../svg/plus.svg'
export { ReactComponent as PokerMenuIcon } from '../svg/Poker-menu.svg'
export { ReactComponent as PopupBgIcon } from '../svg/popup-bg.svg'
export { ReactComponent as ProfileMobIcon } from '../svg/profile-mob.svg'
export { ReactComponent as ProfileUserIcon } from '../svg/ProfileUser.svg'
export { ReactComponent as PromoTextIcon } from '../svg/promo-text.svg'
export { ReactComponent as PromotionMenuIcon } from '../svg/Promotion-menu.svg'
export { ReactComponent as PromotionsArrowIcon } from '../svg/promotionsArrow.svg'
export { ReactComponent as RankUpMenuIcon } from '../svg/Rank-up-menu.svg'
export { ReactComponent as ReawardIcon } from '../svg/reaward.svg'
export { ReactComponent as RewardSvgIcon } from '../svg/reward_icon.svg'
export { ReactComponent as RedCrossIcon } from '../svg/red-cross.svg'
export { ReactComponent as RedLiveCircleIcon } from '../svg/red-live-circle.svg'
export { ReactComponent as RedditChatIcon } from '../svg/reddit-chat.svg'
export { ReactComponent as RefferralsProfileIcon } from '../svg/refferralsProfile.svg'
export { ReactComponent as ReportIcoIcon } from '../svg/report-ico.svg'
export { ReactComponent as RewardRejectIcon } from '../svg/reward-reject.svg'
export { ReactComponent as RewardIcon } from '../svg/reward.svg'
export { ReactComponent as RewardsApplepayIcon } from '../svg/rewards-applepay.svg'
export { ReactComponent as RewardsGpayIcon } from '../svg/rewards-gpay.svg'
export { ReactComponent as RewardsMastercardIcon } from '../svg/rewards-mastercard.svg'
export { ReactComponent as RewardsSamsungpayIcon } from '../svg/rewards-samsungpay.svg'
export { ReactComponent as RewardsTickIcon } from '../svg/rewards-tick.svg'
export { ReactComponent as SearchIconIcon } from '../svg/search-icon.svg'
export { ReactComponent as SelectArrowIcon } from '../svg/select-arrow.svg'
export { ReactComponent as SettingProfileIcon } from '../svg/settingProfile.svg'
export { ReactComponent as SkullBadgeIcon } from '../svg/skull-badge.svg'
export { ReactComponent as SliderLeftArrowGreyIcon } from '../svg/slider-left-arrow-grey.svg'
export { ReactComponent as SliderLeftArrowIcon } from '../svg/slider-left-arrow.svg'
export { ReactComponent as SliderRightArrowGreyIcon } from '../svg/slider-right-arrow-grey.svg'
export { ReactComponent as SliderRightArrowIcon } from '../svg/slider-right-arrow.svg'
export { ReactComponent as SliderStripeIcon } from '../svg/slider-stripe.svg'
export { ReactComponent as SliderThumbIcon } from '../svg/slider-thumb.svg'
export { ReactComponent as SoccerIcon } from '../svg/soccer.svg'
export { ReactComponent as SocialIcon2Icon } from '../svg/social-icon-2.svg'
export { ReactComponent as SocialLink3Icon } from '../svg/social-link-3.svg'
export { ReactComponent as SocialLink4Icon } from '../svg/social-link-4.svg'
export { ReactComponent as SocialTwitchIconNewIcon } from '../svg/social-twitch-icon-new.svg'
export { ReactComponent as SocialIcon } from '../svg/social.svg'
export { ReactComponent as SportsMenuIcon } from '../svg/Sports-menu.svg'
export { ReactComponent as SportsbookFavouritesIcon } from '../svg/sportsbookFavourites.svg'
export { ReactComponent as StatisticsIcon } from '../svg/statistics.svg'
export { ReactComponent as SteamChatIcon } from '../svg/steam-chat.svg'
export { ReactComponent as SwordBadgeIcon } from '../svg/sword-badge.svg'
export { ReactComponent as TableTennisIcon } from '../svg/tableTennis.svg'
export { ReactComponent as TelegramIcon } from '../svg/telegram.svg'
export { ReactComponent as TennisIcon } from '../svg/tennis.svg'
export { ReactComponent as TwitchChatIcon } from '../svg/twitch-chat.svg'
export { ReactComponent as TwitchIconIcon } from '../svg/twitch-icon.svg'
export { ReactComponent as TwitterChatIcon } from '../svg/twitter-chat.svg'
export { ReactComponent as UiChartIcon } from '../svg/ui-chart.svg'
export { ReactComponent as UploadFilesIcon } from '../svg/upload-files.svg'
export { ReactComponent as VectorIcon } from '../svg/Vector.svg'
export { ReactComponent as VerificationIcon } from '../svg/Verification.svg'
export { ReactComponent as VolleyballIcon } from '../svg/volleyball.svg'
export { ReactComponent as VolumIcon } from '../svg/volum.svg'
export { ReactComponent as WalletIcoIcon } from '../svg/wallet-ico.svg'
export { ReactComponent as WhiteDownIcon } from '../svg/white-down.svg'
export { ReactComponent as WithdrawalIcon } from '../svg/withdrawal.svg'
export { ReactComponent as XIcon } from '../svg/x.svg'
export { ReactComponent as FullScreenIcon } from '../svg/full-screen.svg'
export { ReactComponent as FavouritesIcon } from '../svg/favourites.svg'
export { ReactComponent as TrophyIcon } from '../svg/trophy.svg'
export { ReactComponent as ToasterInfo } from '../svg/toaster-info.svg'
export { ReactComponent as ToasterError } from '../svg/toaster-error.svg'
export { ReactComponent as ToasterSuccess } from '../svg/toaster-success.svg'
export { ReactComponent as ToasterWarning } from '../svg/toaster-warning.svg'
export { ReactComponent as ToasterClose } from '../svg/toaster-close.svg'
export { ReactComponent as CryptoHeading } from '../svg/crypto-heding.svg'
export { ReactComponent as NftHeading } from '../svg/nft-heading.svg'
export { ReactComponent as PokerHeading } from '../svg/poker-heading.svg'
export { ReactComponent as LoginSetting } from '../svg/login_setting.svg'
export { ReactComponent as RegisterSetting } from '../svg/register_setting.svg'
export { ReactComponent as FooterLogo } from '../svg/footer_logo.svg'
export { ReactComponent as DownArrow } from '../svg/down-arrow.svg'
export { ReactComponent as UpArrow } from '../svg/up-arrow.svg'
export { ReactComponent as InfoIconGray } from '../svg/info-icon.svg'
